import ShowDetail from "./ShowDetail";

export default ShowDetail;
